var _react_refresh_temp_1, _react_refresh_temp_2;
import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { AllowedStorageType, BillingSubscriptionCategory, dateParser, enumParser, recurringIntervals, } from '#validation';
export const filespaceCreateReasons = [
    'filespace.create.limit.exceeded',
];
export const inviteMembersReasons = [
    'subscription.plan.members.limit.exceeded',
];
// TODO
export const paymentMethods = ['card'];
const MembersCapabilitiesSchema = z.object({
    max: z.number().nullish(),
    current: z.number(),
    pending: z.number(),
    prepaid: z.number(),
    currentUsedSlots: z.number().nullish(),
    canInviteMembers: z.boolean(),
    reasonsInviteMembers: z.array(z.enum(inviteMembersReasons)),
    canInviteOrgMembers: z.boolean(),
});
const FilespacesCapabilitiesSchema = z.object({
    max: z.number().nullish(),
    current: z.number(),
    canCreateFilespace: z.boolean(),
    reasonsCreateFilespace: z.array(z.enum(filespaceCreateReasons)),
});
const StorageCapabilitiesSchema = z.object({
    max: z.number(),
    overage: z.number(),
    current: z.number(),
    used: z.number(),
    includedStoragePerUser: z.number(),
    usedAws: z.number(),
    usedOwn: z.number(),
    usedIbm: z.number().optional(),
    usedWasabi: z.number().optional(),
    prepaidAws: z.number(),
    prepaidOwn: z.number(),
    prepaidIbm: z.number().optional(),
    prepaidWasabi: z.number().optional(),
    overageAws: z.number(),
    overageOwn: z.number(),
    overageIbm: z.number().optional(),
    overageWasabi: z.number().optional(),
    currentAws: z.number().optional(),
    currentOwn: z.number().optional(),
    currentIbm: z.number().optional(),
    currentWasabi: z.number().optional(),
});
export const NativeLayoutStorageCapabilitiesSchema = z.object({
    enabled: z.boolean().optional(),
    current: z.number().optional(),
    used: z.number().optional(),
    prepaid: z.number().optional(),
    overage: z.number().optional(),
});
const ServiceAccountsCapabilitiesSchema = z.object({
    canManage: z.boolean(),
});
export const TeamCacheCapabilitiesSchema = z.object({
    enabled: z.boolean(),
    installations: z.number().optional(),
});
export const AllowedStorageTypesCapabilitiesSchema = z.array(_react_refresh_temp_1 = enumParser(AllowedStorageType));
$RefreshReg$(_react_refresh_temp_1, "AllowedStorageTypesCapabilitiesSchema$z.array");
_react_refresh_temp_2 = AllowedStorageTypesCapabilitiesSchema;
$RefreshReg$(_react_refresh_temp_2, "AllowedStorageTypesCapabilitiesSchema");
const GuestLinksCapabilitiesSchema = z.object({
    canUpdateExpiration: z.boolean(),
    maxGuestLinks: z.number().nullish(),
});
const billingSubscriptionSchema = z.object({
    id: z.number(),
    name: z.string(),
    category: enumParser(BillingSubscriptionCategory),
    // Comes directly from DB, where it's a string. See SubscriptionStatus type from /Common for possible values
    billingStatus: z.string(),
    recurringInterval: z.enum(recurringIntervals),
    prepaidPeriodStart: dateParser().optional(),
    prepaidPeriodEnd: dateParser().optional(),
    overagePeriodEnd: dateParser(),
    overagePeriodStart: dateParser(),
    paymentMethod: z.enum(paymentMethods).nullish(),
    cardLast4: z.string().nullish(),
    prices: z
        .object({
        prepaidUsers: z.number(),
        overageUsers: z.number(),
        overageStorage: z.number(),
        // N/A for Starter and Business plan
        customStorage: z.number().nullish(),
        currency: z.string(),
    })
        .optional(),
    trialDays: z.number(),
    subscriptionLineItems: z.array(z.string()),
    isForMigration: z.boolean().optional(),
});
const billingCapabilitiesResponseSchema = z.object({
    capabilities: z.object({
        members: MembersCapabilitiesSchema.optional(),
        filespaces: FilespacesCapabilitiesSchema.optional(),
        storage: StorageCapabilitiesSchema.optional(),
        serviceAccounts: ServiceAccountsCapabilitiesSchema.optional(),
        allowedStorageTypes: AllowedStorageTypesCapabilitiesSchema.optional(),
        teamCache: TeamCacheCapabilitiesSchema.optional(),
        nativeLayout: NativeLayoutStorageCapabilitiesSchema.optional(),
        guestLinks: GuestLinksCapabilitiesSchema.optional(),
    }),
    subscription: billingSubscriptionSchema.optional(),
});
export class ServiceAccountsCapabilitiesResponseDto extends createZodDto(ServiceAccountsCapabilitiesSchema) {
}
export class MembersCapabilitiesResponseDto extends createZodDto(MembersCapabilitiesSchema) {
}
export class FilespacesCapabilitiesResponseDto extends createZodDto(FilespacesCapabilitiesSchema) {
}
export class StorageCapabilitiesResponseDto extends createZodDto(StorageCapabilitiesSchema) {
}
export class AllowedStorageTypesCapabilitiesResponseDto extends createZodDto(AllowedStorageTypesCapabilitiesSchema) {
}
export class TeamCacheCapabilitiesResponseDto extends createZodDto(TeamCacheCapabilitiesSchema) {
}
export class GuestLinksCapabilitiesRsponseDto extends createZodDto(GuestLinksCapabilitiesSchema) {
}
export class NativeLayoutStorageCapabilitiesResponseDto extends createZodDto(NativeLayoutStorageCapabilitiesSchema) {
}
export class BillingCapabilitiesResponseDto extends createZodDto(billingCapabilitiesResponseSchema) {
}
